<payee-popup>
  <ng-template #payeePopupTitleTemplate>
    <h1>
      {{ "WORKFLOW_DIALOGS.HARD_PAYMENT_PLAN_APPROVE.TITLE" | translate }}
    </h1>
  </ng-template>

  <ng-template #payeePopupDescriptionTemplate>
    <div class="description">
      {{ "WORKFLOW_DIALOGS.HARD_PAYMENT_PLAN_APPROVE.DESCRIPTION" | translate }}
    </div>
  </ng-template>

  <ng-template #payeePopupSubmitTemplate>
    @if (dialogData?.transition_ids?.approve) {
      <button
        class="payee-button"
        payee-button
        color="blue"
        width="max"
        height="normal"
        [disabled]="loading"
        [loading]="loading"
        (click)="submit('approve')"
      >
        <ng-container>
          {{ "WORKFLOW_DIALOGS.HARD_PAYMENT_PLAN_APPROVE.APPROVE" | translate }}
        </ng-container>
      </button>
    }
    @if (dialogData?.transition_ids?.reject) {
      <button
        class="payee-button"
        payee-button
        color="red"
        width="max"
        height="normal"
        [disabled]="loading"
        [loading]="loading"
        (click)="submit('reject')"
      >
        <ng-container>
          {{ "WORKFLOW_DIALOGS.HARD_PAYMENT_PLAN_APPROVE.REJECT" | translate }}
        </ng-container>
      </button>
    }
  </ng-template>

  <ng-template #payeePopupCancelTemplate>
    <button
      class="payee-button"
      payee-button
      color="white"
      width="max"
      height="normal"
      [isBorderButton]="true"
      (click)="cancel()"
    >
      <ng-container>
        {{ "WORKFLOW_DIALOGS.HARD_PAYMENT_PLAN_APPROVE.CANCEL" | translate }}
      </ng-container>
    </button>
  </ng-template>
</payee-popup>
